"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const uuid_1 = require("uuid");
const transactions_1 = require("companion-app-components/flux/transactions");
const categories_1 = require("companion-app-components/flux/categories");
const memorizedRulesActions_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesActions");
const memorizedRulesTypes_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesTypes");
const core_1 = require("companion-app-components/utils/core");
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
// MUI
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const InputBase_1 = __importDefault(require("@mui/material/InputBase"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const LockOutlined_1 = __importDefault(require("@mui/icons-material/LockOutlined"));
const ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
const ExpandLess_1 = __importDefault(require("@mui/icons-material/ExpandLess"));
const ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const Save_1 = __importDefault(require("@mui/icons-material/Save"));
const material_1 = require("@mui/material");
const Tooltip_1 = __importDefault(require("@mui/material/Tooltip"));
// DATA
const utils_1 = require("data/payees/utils");
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const QCheckbox_1 = __importDefault(require("components/QCheckbox"));
const searchFilter_1 = require("data/transactions/searchFilter");
const PayeeAutocomplete_1 = __importDefault(require("components/PayeeAutocomplete"));
const PayeeField_1 = __importDefault(require("components/QuickenControls/PayeeField"));
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const TagsField_1 = __importDefault(require("components/QuickenControls/TagsField"));
const AmountField_1 = __importDefault(require("components/QuickenControls/AmountField"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const SplitsAndDetailsPanel_1 = __importDefault(require("components/SplitsAndDetailsPanel"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const Dump_1 = __importDefault(require("components/Dump"));
const constants_1 = require("utils/constants");
const utils_2 = require("../../utils");
const utils_3 = require("./utils");
const RowStyles_1 = __importDefault(require("./RowStyles"));
const types_1 = require("./types");
const ComplexRuleDetails_1 = __importDefault(require("./ComplexRuleDetails/ComplexRuleDetails"));
const useStyles = (0, mui_1.makeStyles)()(RowStyles_1.default);
const Row = (props) => {
    const { editable, disableAll, setDisableAll, row, removeNewMemorizedPayee } = props;
    const [subMenuAnchorEl, setSubMenuAnchorEl] = React.useState(null);
    const [isEditable, setEditable] = React.useState(editable);
    const [showSplitsAndDetails, setSplitsAndDetails] = React.useState(Boolean(row.split));
    const [showDetails, setDetails] = React.useState(Boolean(row.split));
    const dispatch = (0, react_redux_1.useDispatch)();
    const theme = (0, styles_1.useTheme)();
    const { classes, cx } = useStyles();
    const simpleInputClass = cx({
        [classes.editableClass]: isEditable,
        [classes.nonEditableClass]: !isEditable,
        editable: isEditable,
    });
    const tagStatic = (0, searchFilter_1.makeTagsString)(row.tags, false);
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const categoriesById = (0, react_redux_1.useSelector)(categories_1.categoriesSelectors.getCategoriesById);
    const [showDuplicateCategoryAlert, setShowDuplicateCategoryAlert] = React.useState(false);
    const [showRuleCondition, setShowRuleCondition] = React.useState(false);
    let memorizedRule;
    if (props.row.id && !editable) {
        memorizedRule = props.rules.find((rule) => props.row.id === rule.id);
    }
    const isComplexMemRule = Boolean(memorizedRule && (0, utils_3.isComplexRule)(memorizedRule));
    const ruleType = memorizedRule ? (0, utils_3.getMemorizedRuleType)(memorizedRule) : types_1.MemorizedRuleType.NORMAL;
    let isIncomeCategory = false;
    const handleSubMenuClick = (event) => {
        setSubMenuAnchorEl(event.currentTarget);
    };
    const handleCloseSubMenu = () => {
        setSubMenuAnchorEl(null);
        setShowDuplicateCategoryAlert(false);
    };
    const handleEditable = (disable) => {
        setEditable(disable);
        setDisableAll(disable);
        handleCloseSubMenu();
        removeNewMemorizedPayee();
    };
    const handleFormCancel = () => {
        handleEditable(false);
    };
    const showDisabledSplitInput = () => (<div className={simpleInputClass}>
      <InputBase_1.default value={constants_1.APP_STRING_SPLIT} inputProps={{
            readOnly: true,
            disabled: true,
            classes: { disabled: classes.defaultOverride },
        }}/>
    </div>);
    const renderDisabledInput = () => (<div className={simpleInputClass}>
      <InputBase_1.default value={''} inputProps={{
            readOnly: true,
            disabled: true,
            classes: { disabled: classes.defaultOverride },
        }}/>
    </div>);
    const validateForm = (values) => {
        var _a;
        const errors = {};
        // Check if Payee field is empty or contains only spaces
        if (!((_a = values.payee.payee) === null || _a === void 0 ? void 0 : _a.trim())) {
            errors.payee = 'Required';
        }
        else if (!values.amount) {
            errors.amount = 'Required';
        }
        if (isEditable) {
            const rulesWithSamePayee = (0, utils_3.getMemorizedRuleWithSamePayeeName)(props.rules, values.payee.payee);
            const hasDuplicatePayeeName = rulesWithSamePayee.some((payee) => values.id !== payee.id && !(0, utils_3.isComplexRule)(payee));
            if (hasDuplicatePayeeName) {
                errors.payee = 'Duplicate';
                setShowDuplicateCategoryAlert(true);
            }
            else {
                setShowDuplicateCategoryAlert(false);
            }
        }
        else {
            setShowDuplicateCategoryAlert(false);
        }
        return errors;
    };
    const normalizeMemorizedRuleData = (data) => {
        var _a, _b, _c, _d, _e;
        const splitItems = (_a = data === null || data === void 0 ? void 0 : data.split) === null || _a === void 0 ? void 0 : _a.items;
        if (!splitItems) {
            return data;
        }
        let itemsArray = [];
        if (Array.isArray(splitItems)) {
            itemsArray = splitItems;
        }
        else if (splitItems && 'toArray' in splitItems) {
            itemsArray = splitItems.toArray();
        }
        const filteredItems = itemsArray.filter(({ amount = 0 }) => Math.abs((0, utils_1.getAmountValue)(amount)) > 0);
        if (filteredItems.length > 1) {
            return Object.assign(Object.assign({}, data), { split: Object.assign(Object.assign({}, data.split), { items: filteredItems }) });
        }
        if (filteredItems.length === 1) {
            const [item] = filteredItems;
            const normalizedAmount = (0, utils_1.getAmountValue)(item.amount);
            return Object.assign(Object.assign({}, data), { split: undefined, transactionType: normalizedAmount > 0 ? 'DEPOSIT' : 'PAYMENT', coa: (_b = item.coa) !== null && _b !== void 0 ? _b : data.coa, amount: (_c = item.amount) !== null && _c !== void 0 ? _c : data.amount, memo: (_d = item.memo) !== null && _d !== void 0 ? _d : data.memo, tags: (_e = item.tags) !== null && _e !== void 0 ? _e : data.tags });
        }
        return Object.assign(Object.assign({}, data), { split: undefined });
    };
    const onSubmitForm = (data) => {
        const normalizedData = normalizeMemorizedRuleData(data);
        const { payee } = data.payee;
        if (data.id === 0) {
            const clientId = (0, uuid_1.v4)().toUpperCase();
            dispatch((0, memorizedRulesActions_1.createMemorizedRule)((0, memorizedRulesTypes_1.mkMemorizedRule)(Object.assign(Object.assign({}, normalizedData), { id: null, clientId, payee })), { undo: { userMessage: 'Memorized payee created.' } }));
        }
        else {
            dispatch((0, memorizedRulesActions_1.updateMemorizedRule)((0, memorizedRulesTypes_1.mkMemorizedRule)(Object.assign(Object.assign({}, normalizedData), { payee })), { undo: { userMessage: 'Memorized payee updated.' } }));
        }
        handleEditable(false);
    };
    const onDelete = () => {
        dialogAlert('Delete Confirmation', 'Are you sure you want to delete this memorized payee?', ({ btnPressed }) => {
            if (btnPressed !== 'Yes') {
                return;
            }
            dispatch((0, memorizedRulesActions_1.deleteMemorizedRule)(
            // @ts-expect-error: Type 'string[]' is missing the following properties from type
            (0, memorizedRulesTypes_1.mkMemorizedRule)(row).set('isDeleted', true), { undo: { userMessage: 'Memorized payee deleted.' } }));
        }, ['Yes', 'No']);
    };
    const renderCategoryField = (setFieldValue, values) => {
        if (isEditable && showSplitsAndDetails) {
            return showDisabledSplitInput();
        }
        if (!isEditable && transactions_1.transactionsUtils.isSplitTxn(values)) {
            return (<div className={simpleInputClass}>
          <Typography_1.default> {constants_1.APP_STRING_SPLIT} </Typography_1.default>
        </div>);
        }
        const catObj = values.coa && categoriesById.get(values.coa.id);
        isIncomeCategory = catObj && catObj.type === 'INCOME';
        return <formik_1.Field name="coa" render={({ field }) => (<div className={simpleInputClass}>
          <CategoryField_1.default {...field} onChange={(coa) => setFieldValue(field.name, coa)} disableUnderline={theme.mixins.register.noUnderline} editable={isEditable} InputProps={{ id: 'categories-input' }} disableOnBlur/>
        </div>)}/>;
    };
    const renderTagField = (setFieldValue) => {
        if (isEditable && showSplitsAndDetails) {
            return renderDisabledInput();
        }
        return <formik_1.Field name="tags" render={({ field }) => 
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
          {!isEditable ?
                    <div className={simpleInputClass}>
              <QTip_1.default wrapOnly title={tagStatic}>
                <QTypography_1.default clickable={false}>{tagStatic}</QTypography_1.default>
              </QTip_1.default>
            </div> :
                    <div className={simpleInputClass}>
              <TagsField_1.default {...field} InputProps={{ classes: { root: classes.regInput } }} disableUnderline={theme.mixins.register.noUnderline} onChange={(tags) => setFieldValue(field.name, tags)} id="tags-input"/>
            </div>}
        </>}/>;
    };
    const renderPayeeField = (setFieldValue) => (<formik_1.Field name="payee" render={({ field }) => {
            let payeeContent;
            if (isEditable) {
                payeeContent = (<PayeeAutocomplete_1.default id="payee-input" inputValue={field.value.payee || ''} onInputChange={(event, value, _reason) => (event || value) && setFieldValue(field.name, { payee: value })} onBlur={field.onBlur} onFocus={(event) => event.target.select()} textFieldProps={{
                        variant: 'outlined',
                        margin: 'normal',
                        fullWidth: true,
                        label: '',
                        placeholder: 'Payee',
                        classes: {
                            root: classes.payeeRoot,
                        },
                        InputLabelProps: {
                            classes: {
                                root: classes.payeeLabel,
                                outlined: classes.payeeLabelOutline,
                            },
                        },
                    }} classes={{
                        inputRoot: classes.payeeInput,
                        input: classes.payeeAutocompleteInput,
                    }}/>);
            }
            else if (!props.skipPayeeName) {
                payeeContent = (<div className={simpleInputClass}>
              <PayeeField_1.default id="payee-input" value={field.value} disableUnderline={theme.mixins.register.noUnderline} editable={false}/>
            </div>);
            }
            else {
                payeeContent = <div className={simpleInputClass}></div>;
            }
            return <div>{payeeContent}</div>;
        }}/>);
    const renderMemoField = () => (<formik_1.Field name="memo" render={({ field }) => !isEditable ?
            <div className={simpleInputClass}><Typography_1.default>{field.value}</Typography_1.default></div> :
            <div className={simpleInputClass}><InputBase_1.default id="memo-input" {...field}/></div>}/>);
    const renderAmountField = (setFieldValue) => (<formik_1.Field name="amount" render={({ field }) => <div className={cx(simpleInputClass, classes.amountLabel)}>
          <AmountField_1.default {...field} disableUnderline={theme.mixins.register.noUnderline} onBlur={(e) => setFieldValue('amount', e.target.value)} editable={isEditable} proposedSign={isIncomeCategory ? 1 : -1} omitCents currencySymbol="USD" amountType="amount" id="amount-input" autoComplete="off"/>
        </div>}/>);
    const trackExpandEventForComplexRule = () => {
        var _a;
        if (!memorizedRule)
            return;
        const hasAccounts = Array.isArray(memorizedRule.accountIds) && memorizedRule.accountIds.length > 0;
        const hasAmountRule = !!memorizedRule.amountCondition;
        const amountOperator = (_a = memorizedRule.amountCondition) === null || _a === void 0 ? void 0 : _a.amountMatchingOperator;
        const trackingData = {
            accountRule: hasAccounts ? 'Yes' : 'NO',
            accountsCount: hasAccounts ? memorizedRule.accountIds.length : 0,
            amountRule: hasAmountRule ? 'Yes' : 'NO',
            amountCondition: amountOperator || 'None',
            changePayeeName: memorizedRule.payeeOverride ? 'Yes' : 'NO',
            neverAutoCategorize: memorizedRule.isNotAutoCategorized ? 'NO' : 'YES',
            markAsCleared: memorizedRule.markAsCleared ? 'Yes' : 'NO',
            lockPayee: memorizedRule.markAsCleared ? 'Yes' : 'NO',
        };
        core_1.tracker.track(core_1.tracker.events.categoryRuleView, trackingData);
    };
    const renderExpandButton = () => {
        if (isEditable || !isComplexMemRule) {
            return <div className={classes.nonEditableClass}/>;
        }
        return (<div className={simpleInputClass} style={{ display: 'flex', justifyContent: 'center' }}>
        <IconButton_1.default size="small" onClick={() => {
                setShowRuleCondition(!showRuleCondition);
                if (!showRuleCondition) {
                    trackExpandEventForComplexRule(); // track only when opening a complex rule
                }
            }} aria-label="Toggle rule details">
          {showRuleCondition ? (<ExpandMore_1.default fontSize="small"/>) : (<ChevronRight_1.default fontSize="small"/>)}
        </IconButton_1.default>
      </div>);
    };
    const saveMemTxn = (txnForm, setFieldValue) => {
        if (txnForm) {
            setFieldValue('amount', txnForm.amount);
            setFieldValue('split', txnForm.split);
            setFieldValue('coa', txnForm.coa);
        }
    };
    return (<Slide_1.default direction="left" in mountOnEnter unmountOnExit timeout={800}>
      <div className={cx({ [classes.rowWrapper]: !isEditable })}>
        <formik_1.Formik initialValues={(0, utils_2.initializeMemorizedPayeeForm)(row)} onSubmit={onSubmitForm} validate={validateForm} enableReinitialize>
          {({ dirty, isValid, setFieldValue, resetForm, values }) => (<div>
              <formik_1.Form className={classes.row}>

                <Dump_1.default obj={values}/>

                <div> {renderPayeeField(setFieldValue)} </div>

                <div>{renderExpandButton()}</div>

                <div> {renderCategoryField(setFieldValue, values)} </div>

                <div> {renderTagField(setFieldValue)} </div>

                <div> {renderMemoField()} </div>

                <div> {renderAmountField(setFieldValue)} </div>

                <div className="lock-row">
                  {!isEditable && row.isNotEditableByTransactions && <LockOutlined_1.default className={classes.lockIcon}/>}
                </div>

                <div className="button-section">
                  {isEditable ?
                <>
                        <QIconButton_1.default className={cx({ [classes.validSubmitIcon]: (isValid && dirty) })} type="submit" focusRipple disabled={!isValid} IconComponent={Save_1.default} size="small-target" tooltip="Save" TooltipProps={{ distance: 2 }}/>
                        <QIconButton_1.default focusRipple IconComponent={Close_1.default} onClick={() => {
                        handleFormCancel();
                        resetForm();
                    }} size="small-target" tooltip="Cancel Editing" TooltipProps={{ distance: 3 }}/>
                        <QIconButton_1.default focusRipple IconComponent={!showDetails ? ExpandMore_1.default : ExpandLess_1.default} onClick={() => setDetails(!showDetails)} size="small-target"/>
                      </> :
                <>
                        {isComplexMemRule ? (<Tooltip_1.default title={`This payee has an ${ruleType === null || ruleType === void 0 ? void 0 : ruleType.toLowerCase()} based rule applied. You can only edit it in the Quicken Desktop app.`} placement="top" arrow classes={{ tooltip: classes.whiteTooltip, arrow: classes.whiteArrow }}>
                            <span>
                              <IconButton_1.default onClick={handleSubMenuClick} disabled size="small">
                                <MoreVert_1.default />
                              </IconButton_1.default>
                            </span>
                          </Tooltip_1.default>) : (<IconButton_1.default onClick={handleSubMenuClick} size="small" disabled={disableAll}>
                            <MoreVert_1.default />
                          </IconButton_1.default>)}
                        <Menu_1.default id="long-menu" anchorEl={subMenuAnchorEl} keepMounted open={Boolean(subMenuAnchorEl)} onClose={handleCloseSubMenu} TransitionComponent={Fade_1.default} PaperProps={{ elevation: 1 }}>
                          <MenuItem_1.default onClick={() => handleEditable(true)}>Edit</MenuItem_1.default>
                          <MenuItem_1.default onClick={onDelete}>Delete</MenuItem_1.default>
                        </Menu_1.default>
                      </>}
                </div>
                {isEditable && showDetails &&
                <div className="split-section">
                    <div>
                      <div className={classes.lockWrapper}>
                        <formik_1.Field name="isNotEditableByTransactions" render={({ field }) => (<FormControlLabel_1.default control={<QCheckbox_1.default {...field} size={theme.mixins.register.checkboxSize} id="lock-input" checked={field.value} value={field.value ? field.value.toString() : ''}/>} label={<QTypography_1.default variant="body2">
                                  <b>Lock</b> - Never update this rule automatically
                                </QTypography_1.default>} className={classes.checkbox}/>)}/>
                        <QTypography_1.default className={classes.lockSubText} variant="caption">
                          <LockOutlined_1.default /> = icon shown for a lock rule
                        </QTypography_1.default>
                      </div>
                    </div>
                    <SplitsAndDetailsPanel_1.default txn={new transactions_1.transactionsTypes.CashFlowTransaction(values)} closeFn={() => setSplitsAndDetails(!showSplitsAndDetails)} splitSwitch={() => setSplitsAndDetails(!showSplitsAndDetails)} onAmountChange={(amount) => setFieldValue('amount', amount)} saveFn={(txnForm) => saveMemTxn(txnForm, setFieldValue)} onChangeTxnState={({ split }) => setFieldValue('split', split)} hideFooter showCurrencySymbol forceAutoSave showDetails={false} showSplits={showSplitsAndDetails}/>
                  </div>}
              </formik_1.Form>
              {isEditable && showDuplicateCategoryAlert && (<div className="mt-2">
                  <material_1.Alert severity="warning">
                    A memorized payee with the same payee name already exists. Please edit the existing rule instead of creating a new one.
                  </material_1.Alert>
                </div>)}
              {memorizedRule && showRuleCondition && (<ComplexRuleDetails_1.default memorizedRule={memorizedRule} tagStatic={tagStatic} ruleType={ruleType}/>)}

            </div>)}
        </formik_1.Formik>
      </div>
    </Slide_1.default>);
};
exports.default = Row;
